import p2 from 'p2';
import { Sprite } from 'pixi.js';

import { Game } from '../Game';
import { PhysicsCollisionGroup, PhysicsShapeType, PhysicsUtils } from '../physics';
import { PhysicsComponent } from '../physics/PhysicsComponent';
import { BaseEntity } from './BaseEntity';

export interface CheckpointEntityParams
{
    type: string,
    x: number,
    y: number,
    w: number,
    h: number,
    r: number,
}

export class CheckpointEntity extends BaseEntity
{
    public sprite!: Sprite;
    public params!: CheckpointEntityParams;
    public physics: PhysicsComponent;
    public reached = false;

    constructor()
    {
        super();
        this.physics = this.addComponent(PhysicsComponent as any) as PhysicsComponent;
        this.physics.culling = true;
    }

    public build(params: CheckpointEntityParams): void
    {
        this.physics.clearParts();
        this.params = params;

        const body = PhysicsUtils.createBody({
            x: this.params.x,
            y: this.params.y,
            angle: this.params.r,
            mass: 0,
        }, {
            type: PhysicsShapeType.BOX,
            width: this.params.w,
            height: this.params.h,
            sensor: true,
            group: PhysicsCollisionGroup.OBJECT,
            mask: PhysicsCollisionGroup.VEHICLE,
        });

        this.physics.addParts(body);
    }

    public levelReset(): void
    {
        this.reached = false;
    }

    protected onBeginContact(other: p2.Body): void
    {
        if (this.reached) return;

        const game = this.scene as Game;

        if (game.race.running && game.vehicle.assembled && other.physicsComponent?.entity === game.vehicle.character)
        {
            this.reached = true;
            game.checkpoint.setCheckpoint(this);
        }
    }
}

export class CheckpointFactory
{
    public static match(data: Record<string, any>): boolean
    {
        return data.type === 'TriggerEntity' && data?.props?.checkpoint;
    }

    public static create(game: Game, data: Record<string, any>): void
    {
        const entity = game.pool.get(CheckpointEntity) as CheckpointEntity;

        entity.build(data as CheckpointEntityParams);

        game.level.addEntity(entity);
    }
}

